import {
  Component,
  ViewChild,
  OnInit,
  Input,
  EventEmitter
} from "@angular/core";
import { CommandsService } from "../services/commands.service";
import { LanguageService } from "../services/language.service";
import { TurtleService } from "../services/turtle.service";
import { CanvasService } from "../services/canvas.service";
import { ExamService } from "../services/exam.service";
import { LoginService } from "../services/login.service";
import { EditorContentService } from "../services/editorcontent.service";
import { DebuggerService } from "../services/debugger.service";

import { SessionStorageService } from "../services/sessionstorage.service";

import { BluetoothService } from "../services/bluetooth.service";

import { RestoreCanvasEvent } from "app/lib/Task";

import { damlev_distance } from "levenshtein-damerau";

import { Interval } from "antlr4ts/misc";
import {
  SemanticErrorCause,
  SyntaxErrorCause,
  RuntimeError,
  XLogoSyntaxError,
  XLogoSemanticError
} from "app/xlogo-parser";
import { CanvasActionSet } from "app/actionSets/canvasActionSet";
import { InterpreterService } from "app/services/interpreter.service";
import { Ace } from "app/lib/ace-builds/src-noconflict/ace";
import { RootService } from "app/services/root.service";
import { CanvasComponent } from "./canvas.component";
import { BlocksService } from "app/services/blocks.service";
import { GridService } from "app/services/grid.service";
import { ShakerService } from "app/services/shaker.service";
import { timingSafeEqual } from "crypto";

declare var swal: any;

@Component({
  selector: "app-input",
  templateUrl: "./input.component.html",
  providers: []
})
export class InputComponent implements OnInit {
  static updateTurtleSpeed = function(speed: number) {};

  //static object
  static inputComponent: InputComponent;

  //user uuid. user in syntax error gathering
  private uuid;
  private sequenceNumber;

  public static readonly SOURCE_NAME = "input";

  private inputLine: any; //Ace.Editor;

  private lastEditorChange: number = 0;
  private readonly EDITOR_CHANGE_DELAY: number = 2000;

  constructor(
    public et: EditorContentService,
    private debuggerService: DebuggerService,
    private lang: LanguageService,
    private commandsService: CommandsService,
    private sessionstorage: SessionStorageService,
    private blocks: BlocksService,
    private examService: ExamService,
    private login: LoginService,
    private interpreterService: InterpreterService,
    private bluetoothService: BluetoothService,
    private canvasService: CanvasService,
    private rootRobotService: RootService,
    private shakerService: ShakerService,
    private gridService: GridService
  ) {
    InputComponent.inputComponent = this;

    this.examService.reExecutionNeededEmitter.subscribe(event =>
      this.reStoreCanvas(event)
    );

    this.interpreterService.registerEventListenerStarted(
      this.onInterpreterStart.bind(this)
    );
    this.interpreterService.registerEventListenerFinished(
      this.onInterpreterEnd.bind(this)
    );
  }

  reStoreCanvas(event: RestoreCanvasEvent) {
    if (event != null) {
      var editorContent = event.editorContent;
      var commands = event.commands;
      for (var i = 0; i < commands.length; i++) {
        if (commands[i] != null) {
          //this.executeCommand(commands[i], this.et.ParsedPrograms, false);
        }
      }
    }
  }

  ngOnInit() {
    this.inputLine = (<any>window).ace.edit("inputEditor");
    this.inputLine.setTheme("ace/theme/kr_theme"); // kuroir
    this.inputLine.getSession().setMode("ace/mode/python");

    // Change appearance to resemble input field instead of code editor
    this.inputLine.setShowPrintMargin(false);
    this.inputLine.renderer.setShowGutter(true);
    this.inputLine.session.gutterRenderer = {
      getWidth: function(session, lastLineNumber, config) {
        return 0;
      },
      getText: function(session, row) {
        return "";
      }
    };
    this.inputLine.setOption("highlightActiveLine", false);
    this.inputLine.setOption("maxLines", 1);
    this.inputLine.renderer.setScrollMargin(15, 0, 0, 0);
    this.inputLine.renderer.updateFontSize();
    this.inputLine.commands.bindKey("Shift-Enter", "null");
    this.inputLine.commands.bindKeys({ "Ctrl-L": null, "Ctrl-F": null });

    // Intercept 'enter' keystrokes and remove it, execute commands instead
    this.inputLine.commands.addCommand({
      name: "exec",
      bindKey: {
        win: "Enter",
        mac: "Enter"
      },
      exec: function(this: InputComponent, editor, line) {
        if (!this.inputLine.getReadOnly()) {
          let commands = this.inputLine.getSession().getLine(0);
          this.addElem(commands);
        }
      }.bind(this),
      readOnly: true
    });

    /*
		Filter out newline characters on paste by creating a proxy
		function which is used to inject code into the onPaste
		function of inputLine
	*/
    (function(this: InputComponent) {
      this.inputLine.originalOnPaste = this.inputLine.onPaste;
      this.inputLine.onPaste = function(this: InputComponent, text, event) {
        let incoming = text.replace(/(\r\n|\n|\r)/gm, " ");
        this.inputLine.originalOnPaste(incoming, event);
      }.bind(this);
    }.bind(this)());

    // Add empty message node for placeholder text
    let node = (this.inputLine.renderer.emptyMessageNode = document.createElement(
      "div"
    ));
    node.textContent = this.lang.translateKey("enterCommand");
    node.style.color = "gray";
    node.style.padding = "15px 5px";
    this.inputLine.renderer.scroller.appendChild(node);

    // Add placeholder text if nothing is written
    this.checkPlaceholderText();
    this.inputLine.on("input", this.checkPlaceholderText.bind(this));
    this.inputLine.on("focus", this.onEditorGotFocus.bind(this));
    //TODO: DAS IST MOEGLICHERWEISE PROBLEMATISCH! ACHTUNG VIELLEICHT WOLLEN WIR DAS AUSKOMMENTIEREN ODER IRGENDWAS VON DER ART? WIR WERDEN ES SEHEN!
    this.inputLine.on("change", this.emitInputChangeEvent.bind(this));

    //disable editor
    this.et.editorEnabler.emit(false);

    //register eventlistener for editor change
    this.et.textInDisplayHasChangedEmitter.subscribe(() =>
      this.onEditorChanged()
    );

    //set headline text to "initialize"
    this.lang.setHeadLineTextTo(
      this.lang.translateKey("init"),
      "headerText_init"
    );

    //ugly hack for first syntax check, which takes much longer: start on startup...
    setTimeout(
      function(this: InputComponent) {
        CanvasComponent.canvasComponent.load();
        this.initializeParser();
      }.bind(this),
      350
    );

    //initialize uuid for this user. Used in syntax error gathering
    const uuidv1 = require("uuid/v1");
    this.uuid = uuidv1();

    //initialize sequence number once
    this.sequenceNumber = 0;

    // Set up input line as one-line ace editor
    this.commandsService.setInputLine(this.inputLine);
    this.commandsService.setLangService(this.lang);
  }

  private onEditorChanged() {
    this.lastEditorChange = Date.now();
    setTimeout(
      function(this: InputComponent, startTime: number) {
        // Only parse if no other task has been started
        if (this.lastEditorChange > startTime) return;

        // Syntax and semantic error markers and annotations
        this.inputLine.session.clearAnnotations();
        const markers: { [index: number]: Ace.MarkerLike } = <
          { [index: number]: Ace.MarkerLike }
        >this.inputLine.session.getMarkers(true);
        for (let marker in markers) {
          this.inputLine.session.removeMarker(markers[marker].id);
        }

        this.interpreterService.setInput(
          InputComponent.SOURCE_NAME,
          this.inputLine.getValue(),
          this.onParseFailure.bind(this)
        );
      }.bind(this),
      this.EDITOR_CHANGE_DELAY,
      this.lastEditorChange
    );
  }

  private onEditorGotFocus() {
    // Syntax and semantic error markers and annotations
    this.inputLine.session.clearAnnotations();
    const markers: { [index: number]: Ace.MarkerLike } = <
      { [index: number]: Ace.MarkerLike }
    >this.inputLine.session.getMarkers(true);
    for (let marker in markers) {
      this.inputLine.session.removeMarker(markers[marker].id);
    }

    this.interpreterService.setInput(
      InputComponent.SOURCE_NAME,
      this.inputLine.getValue(),
      this.onParseFailure.bind(this)
    );
  }

  private checkPlaceholderText() {
    var shouldShow = !this.inputLine.session.getValue().length;
    var node = this.inputLine.renderer.emptyMessageNode;

    if (shouldShow) {
      node.textContent = this.lang.translateKey("enterCommand");
    } else {
      node.textContent = "";
    }
  }

  private emitInputChangeEvent() {
    // Syntax and semantic error markers and annotations
    this.inputLine.session.clearAnnotations();
    const markers: { [index: number]: Ace.MarkerLike } = <
      { [index: number]: Ace.MarkerLike }
    >this.inputLine.session.getMarkers(true);
    for (let marker in markers) {
      this.inputLine.session.removeMarker(markers[marker].id);
    }

    // Runtime error markers
    const markersBack: { [index: number]: Ace.MarkerLike } = <
      { [index: number]: Ace.MarkerLike }
    >this.inputLine.session.getMarkers(false);
    for (let marker in markersBack) {
      this.inputLine.session.removeMarker(markersBack[marker].id);
    }

    this.interpreterService.setInput(
      InputComponent.SOURCE_NAME,
      this.inputLine.getValue(),
      this.onParseFailure.bind(this)
    );
    this.commandsService.emitInputChangeEvent();
  }

  initializeParser() {
    //load speedRange and editorContent from last session from localstorage, TODO: retrieve text for multiple tabs
    this.sessionstorage.retrieveSpeed();
    this.sessionstorage.retrieveEditorContent();

    //this.executeCommand("pu fd 0 pd cs", this.et.ParsedPrograms, false);
    this.inputLine.setReadOnly(false);
    (<HTMLButtonElement>document.getElementById("stopExec")).disabled = true;
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleButton()
    );
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleSwitch()
    );
    this.lang.setHeadLineTextTo(
      this.login.headLineTextUserOrXLogoOnline(),
      "headerText_XLogoOnline"
    );
    this.et.enableEditor();
  }

  // the the current text element to the CommandService, which is bound to the HistoryComponent and will thus annotate the command there
  // if there is no error in the command itself
  addElem(newElem: string) {
    if (newElem) {
      this.interpreterService.startExecution(
        [
          new CanvasActionSet(
            this.bluetoothService,
            this.commandsService,
            this.canvasService,
            this.rootRobotService,
            this.gridService
          )
        ],
        this.debuggerService.getDebugMode()
      );
    }
  }

  private onParseFailure(
    syntaxErrors: XLogoSyntaxError[],
    semanticErrors: XLogoSemanticError[]
  ): void {
    this.inputLine.session.clearAnnotations();
    const markers: { [index: number]: Ace.MarkerLike } = <
      { [index: number]: Ace.MarkerLike }
    >this.inputLine.session.getMarkers(true);

    for (let marker in markers) {
      this.inputLine.session.removeMarker(markers[marker].id);
    }

    const errMsgs: Ace.Annotation[] = [];
    for (const err of syntaxErrors) {
      const error: Ace.Annotation = {
        column: err.token!.startIndex,
        row: err.token!.line - 1,
        text: this.lang.translateKey(
          SyntaxErrorCause[err.cause],
          err.translationParameters
        ),
        type: "error"
      };
      errMsgs.push(error);
      const Range = (<any>window).ace.require("ace/range").Range;
      const range: Ace.Range = new Range(
        err.token!.line - 1,
        err.token!.charPositionInLine,
        err.token!.line - 1,
        err.token!.charPositionInLine + err.token!.text!.length
      );
      this.inputLine.session.addMarker(
        range,
        "markerSyntaxError",
        "text",
        true
      );
    }
    for (const err of semanticErrors) {
      let error: Ace.Annotation = {
        column: err.ast.Range!.StarColumn,
        row: err.ast.Range!.StartLine - 1,
        text: this.lang.translateKey(
          SemanticErrorCause[err.cause],
          err.translationParameters
        ),
        type: "error"
      };

      errMsgs.push(error);
      const Range = (<any>window).ace.require("ace/range").Range;
      const range: Ace.Range = new Range(
        err.ast.Range!.StartLine - 1,
        err.ast.Range!.StarColumn,
        err.ast.Range!.EndLine - 1,
        err.ast.Range!.EndColumn
      );
      this.inputLine.session.addMarker(
        range,
        "markerSyntaxError",
        "text",
        true
      );
    }
    this.inputLine.session.setAnnotations(errMsgs);
  }

  private onInterpreterStart(
    input: string,
    started_successfully: boolean,
    syntaxError: XLogoSyntaxError[],
    semanticError: XLogoSemanticError[]
  ) {
    this.commandsService.addCommand(input);

    const markers: { [index: number]: Ace.MarkerLike } = <
      { [index: number]: Ace.MarkerLike }
    >this.inputLine.session.getMarkers(false);
    for (let marker in markers) {
      this.inputLine.session.removeMarker(markers[marker].id);
    }

    if (!started_successfully) {
      const errMsgs: string[] = [];
      syntaxError.forEach(err =>
        errMsgs.push(
          this.lang.translateKey(
            SyntaxErrorCause[err.cause],
            err.translationParameters
          )
        )
      );
      semanticError.forEach(err =>
        errMsgs.push(
          this.lang.translateKey(
            SemanticErrorCause[err.cause],
            err.translationParameters
          )
        )
      );
      this.commandsService.addErrorMessage(errMsgs, input);

      // TEMP: Collect all syntax errors we receive in the programming environment using /syntax hook
      var xmlhttpContent = new XMLHttpRequest();
      var d = new Date();
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      xmlhttpContent.open("POST", "https://xlogo.inf.ethz.ch/foo/syntax", true);
      xmlhttpContent.setRequestHeader("Content-Type", "application/json");
      xmlhttpContent.send(
        JSON.stringify({
          content:
            "{v: '3.6', sn: '" +
            this.sequenceNumber +
            "', i: '" +
            input +
            "', e: '" +
            this.et.editorText.replace(/\n/g, " \\n ") +
            "', syn: '" +
            syntaxError.length +
            "', sem: '" +
            semanticError.length +
            "', run: '?', d: '" +
            d.toLocaleDateString("de-DE", options) +
            "', t: '" +
            d.toLocaleTimeString("de-DE") +
            "', u: '" +
            this.uuid +
            "'} \n"
        })
      );
      this.sequenceNumber = this.sequenceNumber + 1;
    } else {
      this.disableUI();
      this.lang.setHeadLineTextTo(
        this.lang.translateKey("executingVisitor"),
        "headerText_XLogoOnline"
      );
    }
  }
  private onInterpreterEnd(
    input: string,
    runtimeError: RuntimeError | undefined
  ) {
    this.enableUI();
    CanvasComponent.canvasComponent.flush();
    this.lang.setHeadLineTextTo(
      this.login.headLineTextUserOrXLogoOnline(),
      "headerText_XLogoOnline"
    );
    if (!runtimeError) {
      this.commandsService.setCommandLineText("");
    } else {
      let errMsg: string = runtimeError.message;
      if (runtimeError.translationKey) {
        errMsg = this.lang.translateKey(
          runtimeError.translationKey,
          runtimeError.translationParameters
        );
      }
      if (runtimeError.ast) {
        this.commandsService.addErrorMessage(
          [errMsg],
          `${runtimeError.ast.InputSource}: ${
            runtimeError.ast.Range!.StartLine
          }.${
            runtimeError.ast.Range!.StarColumn
          }: ${runtimeError.ast.CharStream!.getText(
            new Interval(
              runtimeError.ast.Range!.StartStreamIndex,
              runtimeError.ast.Range!.EndStreamIndex
            )
          )}`
        );

        if (runtimeError.ast.InputSource === InputComponent.SOURCE_NAME) {
          const Range = (<any>window).ace.require("ace/range").Range;
          const range = new Range(
            runtimeError.ast!.Range!.StartLine - 1,
            runtimeError.ast!.Range!.StarColumn,
            runtimeError.ast!.Range!.EndLine - 1,
            runtimeError.ast!.Range!.EndColumn
          );
          this.inputLine.session.addMarker(
            range,
            "markerRuntimeError",
            "text",
            false
          );
        }
      } else {
        this.commandsService.addErrorMessage([errMsg], input);
      }

      // TEMP: Collect all syntax errors we receive in the programming environment using /syntax hook
      var xmlhttpContent = new XMLHttpRequest();
      var d = new Date();
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      xmlhttpContent.open("POST", "https://xlogo.inf.ethz.ch/foo/syntax", true);
      xmlhttpContent.setRequestHeader("Content-Type", "application/json");
      xmlhttpContent.send(
        JSON.stringify({
          content:
            "{v: '3.6', sn: '" +
            this.sequenceNumber +
            "', i: '" +
            input +
            "', e: '" +
            this.et.editorText.replace(/\n/g, " \\n ") +
            "', syn: '0', sem: '0', run: 'y', d: '" +
            d.toLocaleDateString("de-DE", options) +
            "', t: '" +
            d.toLocaleTimeString("de-DE") +
            "', u: '" +
            this.uuid +
            "'} \n"
        })
      );
      this.sequenceNumber = this.sequenceNumber + 1;
    }
  }

  disableUI() {
    this.inputLine.setReadOnly(true);
    (<HTMLButtonElement>document.getElementById("stopExec")).disabled = false;
    if (!this.debuggerService.getDebugMode()) {
      this.debuggerService.disableButton(
        this.debuggerService.getDebugToggleButton()
      );
      this.debuggerService.disableButton(
        this.debuggerService.getDebugToggleSwitch()
      );
    }
  }

  enableUI() {
    // Enable UI elements again
    this.inputLine.setReadOnly(false);
    (<HTMLButtonElement>document.getElementById("stopExec")).disabled = true;
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleButton()
    );
    this.debuggerService.enableButton(
      this.debuggerService.getDebugToggleSwitch()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/input.component.ts